// utils/auth.js
export const saveToken = (token) => {
  localStorage.setItem("authToken", token);
};

export const getToken = () => {
  return localStorage.getItem("authToken");
};


export const clearToken = () => localStorage.removeItem("collectorToken");
export const isLoggedIn = () => !!getToken();

// export const saveUser = (user) => localStorage.setItem("collectorUser", JSON.stringify(user));
// export const getUser = () => {
//   const v = localStorage.getItem("collectorUser");
//   return v ? JSON.parse(v) : null;
// };
export const clearUser = () => localStorage.removeItem("collectorUser");
// src/utils/auth.js
export const saveUser = (user) =>
  localStorage.setItem("collectorUser", JSON.stringify(user));


export const getUser = () => {
  const userStr = localStorage.getItem("collectorUser");
  if (!userStr) return null;
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error("Error parsing user from localStorage", error);
    return null;
  }
};
